import { useUser } from '@clerk/clerk-react';
import { ROLES, type Role } from '@/constants/roles';

export const useRole = () => {
  const { user } = useUser();
  const role = user?.publicMetadata.role as Role | undefined;

  return {
    role,
    isClient: role === ROLES.CLIENT,
    isInstructor: role === ROLES.INSTRUCTOR,
    isUser: role === ROLES.USER,
    isAdmin: role === ROLES.ADMIN,
    isSuperAdmin: role === ROLES.SUPERADMIN,
  };
};
